import React from 'react';
import ProductionLineManagement from '../ProductionLineManagement';

interface ProductionLinesTabProps {
  onError: (error: string) => void;
}

const ProductionLinesTab: React.FC<ProductionLinesTabProps> = ({ onError }) => {
  return (
    <div className="card">
      <ProductionLineManagement onError={onError} />
    </div>
  );
};

export default ProductionLinesTab;
